import { Status } from "@/types"
import { atom } from "jotai"

/**
 * Merchant-level catalog status (`ApiData.status`) — the portal "open store"
 * toggle. UNAVAILABLE closes every channel; AVAILABLE never overrides a
 * channel that is outside its own schedule.
 */
const merchantStatusAtom = atom<Status | null>(null)

export default merchantStatusAtom
